import React from 'react';

export class TaskErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("TaskErrorBoundary caught an error:", error, errorInfo);
        this.setState({ errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '20px', background: '#fee2e2', color: '#991b1b', borderRadius: '8px', margin: '20px', fontFamily: 'monospace', overflow: 'auto', maxHeight: '100%' }}>
                    <h3>Error de Renderizado (Producido en Producción)</h3>
                    <p><b>Mensaje:</b> {this.state.error && this.state.error.toString()}</p>
                    <details style={{ whiteSpace: 'pre-wrap', marginTop: '10px' }}>
                        <summary>Ver Stack Trace Completo (Por favor toma captura de esto)</summary>
                        {this.state.errorInfo && this.state.errorInfo.componentStack}
                        {'\n\n'}
                        {this.state.error && this.state.error.stack}
                    </details>
                </div>
            );
        }
        return this.props.children;
    }
}
